import LockIcon from "@assets/icons/lock.svg";
import { Rect } from "shared/components/atoms/Rect";
import tw from "twin.macro";

const subTitleCss = tw`font-semibold text-xs leading-3 tracking-[.8px] text-[#0c0f48] mt-7`;
const contentCss = tw`font-normal text-2xs leading-[15px] text-[#0c0f48] mt-1`;

interface Props {
  className?: string;
}

export const SafetyPolicy = ({ className }: Props) => {
  return (
    <Rect
      tw="rounded-3xl py-8 px-4 border-2 border-[#50E3C2] bg-white items-center text-center"
      className={className}
    >
      <LockIcon
        width={100}
        viewBox="0 0 28 30.27"
        tw="svg absolute -top-4 text-[#50e3c2] bg-white"
      />
      <h3 tw="font-semibold text-base leading-4 tracking-[.8px] text-[#0c0f48]">
        安心・安全への取り組み
      </h3>
      <h4 css={subTitleCss}>① カルテの情報は厳重に管理しています</h4>
      <p css={contentCss}>
        カルテの情報はお申込みいただいた占いの鑑定のみに使用され、それ以外の目的で使用しません。また、お申込みいただいた占い師のみに公開され、他の占い師やユーザーに公開されることはありません。
      </p>
      <h4 css={subTitleCss}>② 代金は鑑定終了まで運営がお預かり</h4>
      <p css={contentCss}>
        MIRORでは、鑑定が終了するまで料金を運営事務局にてお預かりしています。万が一、鑑定が行われなかった場合は運営にてご返金を行いますので、ご安心してご利用ください。
      </p>
    </Rect>
  );
};
